<div class="uploader-service-container">
    <app-smash-header [step]="step$ | async" 
        [theme]="theme" 
        [headerColor]="theme?.teasing?.layoutHeaderColor"
        [captionColor]="theme?.teasing?.captionColor" 
        [shadowOnElementsEnabled]="theme?.teasing?.layoutShadowElementEnabled" 
        showMenu="true"
        (menuToggle)="onToggleMenu($event)" 
        (switchUploaderMode)="onSwitchUploaderMode($event)" 
        [state]="menuDisplayed$ | async"
        [selectedTeam]="selectedTeam$ | async" 
        [dropboxPreview]="dropboxPreview$ | async" 
        [dropboxPreviewLoading]="dropboxPreviewLoading$ | async"
        [isLoggedIn]="hasToken$ | async" 
        [uploaderMode]="uploaderMode$ | async" 
        [step]="step$ | async" 
        [domain]="domain">
    </app-smash-header>
    <!-- Image backkround -->
    <ng-container >
        <div [@routingTransition]>
            <router-outlet class="uploader-router" #o="outlet"></router-outlet>
        </div>
        <div class="background-container" [ngClass]="{'displayed': theme || (!isDomainManaged && domain?.background) }">
            <ng-container *ngIf="!themeLoading && theme">
                <div class="container-background-image" 
                    *ngIf="theme?.teasing?.background?.type === 'Image'"
                    [appBackgroundImage]="theme?.teasing?.background?.url" 
                    [attr.id]="themeBackgroundHtmlIdentifier"></div>
                <div class="container-youtube" 
                    [attr.id]="themeBackgroundHtmlIdentifier"
                    *ngIf="theme?.teasing?.background?.type === 'Youtube' || theme?.teasing?.background?.type === 'Vimeo' || theme?.teasing?.background?.type === 'Video'">
                    <app-smash-player 
                        [fullscreen]="true" 
                        [source]="playerSource"
                        context="cover"
                        [options]="playerOptions" 
                        class="smash-sound-player"
                        (readyToPlay)="isVideoBgReadyToPlay($event)" 
                        [allowConcurrency]="true">
                    </app-smash-player>
                    <div [ngClass]="{'fadeOut': showVideo}" class="video-overlay-loading"></div>
                </div>
                <app-smash-theme-tracking [theme]="theme"></app-smash-theme-tracking>
            </ng-container>
            <ng-container *ngIf="!themeLoading && !theme && domain?.background">
                <div class="container-background-image" 
                    *ngIf="domain.background.type === 'Image'"
                    [attr.id]="domain?.background?.id ? domain.background.id : null" 
                    appBackgroundImage="{{ domain.background.sourceUrl }}">
                </div>
    
                <!-- Youtube/Vimeo background -->
                <div class="container-youtube" 
                    [attr.id]="domain?.background?.id ? domain.background.id : null"
                    *ngIf="(domain.background.type === 'Youtube' || domain.background.type === 'Vimeo')">
                    <app-smash-player 
                    [fullscreen]="true" 
                    [source]="playerSource" 
                    context="cover"
                    [options]="playerOptions" 
                    class="smash-sound-player"
                    (readyToPlay)="isVideoBgReadyToPlay($event)" 
                    [allowConcurrency]="true">
                    </app-smash-player>
                    <div [ngClass]="{'fadeOut': showVideo}" class="video-overlay-loading"></div>
                </div>
            </ng-container>
            <div class="background-overlay" [ngClass]="{'visible': (step$ | async) === 'PREPARE' }"></div>
        </div>
    </ng-container>

    <app-smash-manufacture *ngIf="!(isPremium$ | async) && !themeLoading && !theme" class="manufacture" [selectedLanguage]="selectedLanguage$ | async">
    </app-smash-manufacture>
    <app-smash-trustpilot *ngIf="!(isPremium$ | async)"class="trustpilot"></app-smash-trustpilot>
</div>